export default {
  labels: {
    dont_have_account: 'Nie masz konta? ',
  },
  title: 'Dołącz do {{name}}!',
  default_program_name: 'Klub nagród',
  buttons: {
    sign_up: 'Zarejestruj się',
  },
};
